module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-MIP-Data-Memory-2.653e917f.png";